package models

data class WeddingInfo(
    val name: String,
    val date: String,
    val time: String,
    val location: String,
    val mapLink: String? = null
)

fun getResepsi(): List<WeddingInfo> {
    val listOf = listOf(
        WeddingInfo(
            name = "Akad Nikah",
            date = "Minggu, 5 April 2026",
            time = "08.00 – 09.00 WIB",
            location = "Dsn. Campedan, Rengel - Tuban",
            mapLink = null
        ),
        WeddingInfo(
            name = "Resepsi",
            date = "Minggu, 5 April 2026",
            time = "10.00 – 14.00 WIB",
            location = "Dsn. Campedan, Rengel - Tuban",
            mapLink = "https://maps.app.goo.gl/su9zoDY5u5G8wWmJ9"
        )
    )
    return listOf
}

fun getUnduhMantu(): List<WeddingInfo> {
    val listOf = listOf(
        WeddingInfo(
            name = "Unduh Mantu",
            date = "Selasa, 7 April 2026",
            time = "10.00 WIB – Selesai",
            location = "Perum. BPH Blok L3/2, Benjeng - Gresik",
            mapLink = "https://maps.app.goo.gl/uP8D1WW1ckbQ4vxv9"
        )
    )
    return listOf
}